import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
const DownloadLink = ({ fileUrl, fileName, title }) => {
  return (
    <Link
      className="my-1"
      style={{ display: 'flow-root' }}
      to={fileUrl}
      target="_blank"
      download={fileName}
      rel="noopener noreferrer"
    >
      {title}
    </Link>
  );
};

DownloadLink.propTypes = {
  fileUrl: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired,
  title: PropTypes.string
};

export default DownloadLink;
